import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row, Container } from "react-bootstrap";
// import img1 from "../../assets/img/sections/istockphoto-176995901-612x612.jpg";
// import img2 from "../../assets/img/sections/e89401fd8cebd4aec38199cdebe727e1.jpg";
// import img3 from "../../assets/img/sections/muslims-reading-from-quran.jpg";
import { LoadingDots, ServerDown } from "../../components/general";
import { getFeaturesPageContent } from "../../services/publicPages";
import styles from "./features.module.css";

export const Features = () => {
  const { i18n } = useTranslation();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [serverUnavailable, setServerUnavailable] = useState(false);

  const featureStyle = (color) => {
    const border = i18n.dir() === "rtl" ? "borderRight" : "borderLeft";
    return {
      display: "flex",
      alignItems: "start",
      justifyContent: "center",
      flexDirection: "column",
      padding: "0.5rem 1rem",
      [border]: `8px solid ${color}`,
    }
  };

  // fetch home page content from backend
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await getFeaturesPageContent(i18n.language);
        setData(data);
        setLoading(false);
      } catch (err) {
        if (!err?.response) {
          setServerUnavailable(true);
        }
      }
    };

    fetchData();
  }, [i18n.language]);

  return (
    <>
      {serverUnavailable ? (
        <ServerDown />
      ) : loading ? (
        <LoadingDots />
      ) : (
      <>
        {/* Hero Section */}
        <section className={`section my-lg-3 ${styles.hero}`}>
          <Container>
            <Row className="align-items-center justify-content-between g-4">
              {/* Left Column */}
              <Col lg={6} className="order-2 order-lg-1 d-flex flex-column justify-content-center">
                <h2 className="s-fs-2">{data.section1Title}</h2>
                <p className="section-text">{data.section1Description}</p>
              </Col>

              {/* Right Column */}
              <Col lg={6} className="order-1 order-lg-2 text-center">
                <img src={data.section1Image} className={`img-fluid ${styles.heroImg}`} alt="" />
              </Col>
            </Row>

          </Container>
        </section> {/* /Hero Section */}

        <section className="section">
          <Container>
            <Row className="align-items-center justify-content-center text-center mb-4">
              <h3 className="s-fs-3 mb-3">{data.section2Title}</h3>
              <p className="col-12 col-md-9 text-muted">{data.section2Description}</p>
            </Row>

            <Row className="g-lg-4">
              <Col md={6} className="mb-4">
                <div className="d-flex h-100">
                  <div style={featureStyle("var(--s-fuchia-color)")}>
                    <h4 className="s-fs-4">{data.section2Card1Title}</h4>
                    <p className="mb-0">{data.section2Card1Description}</p>
                  </div>
                </div>
              </Col>
              
              <Col md={6} className="mb-4">
                <div className="d-flex h-100">
                  <div style={featureStyle("var(--s-purple-color)")}>
                    <h4 className="s-fs-4">{data.section2Card2Title}</h4>
                    <p className="mb-0">{data.section2Card2Description}</p>
                  </div>
                </div>
              </Col>

              <Col md={6} className="mb-4">
                <div className="d-flex h-100">
                  <div style={featureStyle("var(--s-yellow-color)")}>
                    <h4 className="s-fs-4">{data.section2Card3Title}</h4>
                    <p className="mb-0">{data.section2Card3Description}</p>
                  </div>
                </div>
              </Col>
              
              <Col md={6} className="mb-4">
                <div className="d-flex h-100">
                  <div style={featureStyle("var(--s-black-color)")}>
                    <h4 className="s-fs-4">{data.section2Card4Title}</h4>
                    <p className="mb-0">{data.section2Card4Description}</p>
                  </div>
                </div>
              </Col>

              <Col md={6} className="mb-4">
                <div className="d-flex h-100">
                  <div style={featureStyle("var(--s-purple-color)")}>
                    <h4 className="s-fs-4">{data.section2Card5Title}</h4>
                    <p className="mb-0">{data.section2Card5Description}</p>
                  </div>
                </div>
              </Col>
              
              <Col md={6} className="mb-4">
                <div className="d-flex h-100">
                  <div style={featureStyle("var(--s-fuchia-color)")}>
                    <h4 className="s-fs-4">{data.section2Card6Title}</h4>
                    <p className="mb-0">{data.section2Card6Description}</p>
                  </div>
                </div>
              </Col>

              <Col md={6} className="mb-4">
                <div className="d-flex h-100">
                  <div style={featureStyle("var(--s-black-color)")}>
                    <h4 className="s-fs-4">{data.section2Card7Title}</h4>
                    <p className="mb-0">{data.section2Card7Description}</p>
                  </div>
                </div>
              </Col>
              
              <Col md={6} className="mb-4">
                <div className="d-flex h-100">
                  <div style={featureStyle("var(--s-yellow-color)")}>
                    <h4 className="s-fs-4">{data.section2Card8Title}</h4>
                    <p className="mb-0">{data.section2Card8Description}</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

    {/* <section className="section">
          <Container>
            <Row>
              <Col md={7} sm={12} className="d-flex flex-column justify-content-center">
                <h2 className="s-fs-2 mb-4">Islamic Education</h2>
                <p className="section-text">
                  Sabeqoon provides everything Islamic educational institutions
                  need to streamline operations, enhance student learning, and
                  maintain effective communication between teachers,
                  administrators, and parents.
                </p>
              </Col>

              <Col md={5} sm={12} className="">
                <div>
                  <Row className={`g-3 ${styles.imageGallery}`}>
                    // Left Column - Single Image 
                    <Col xs={6} className={styles.imageColumn}>
                      <div className={styles.imageWrapper}>
                        <img src={img1} alt="Feature 1" className={`img-fluid ${styles.galleryImage}`} />
                      </div>
                    </Col>
                    
                    // Right Column - Two Images
                    <Col xs={6} className={styles.imageColumn}>
                      <div className={styles.imageWrapper}>
                        <img src={img2} alt="Feature 2" className={`img-fluid ${styles.galleryImage}`} />
                      </div>
                      <div className={`${styles.imageWrapper} mt-3`}>
                        <img src={img3} alt="Feature 3" className={`img-fluid ${styles.galleryImage}`} />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </section> */}
      </>
      )}
    </>
  );
};
